import { AfterContentInit, Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[appFocus]',
  standalone: false,
})
export class FocusDirective implements AfterContentInit {
  public constructor(private readonly elementRef: ElementRef) {}

  public ngAfterContentInit(): void {
    setTimeout(() => {
      this.elementRef.nativeElement.focus();
    }, 500);
  }
}
